<template>
  <div class="col c-support-bar__section">
        <div class="c-support-bar__content">
            <h2 class="h6 c-support-bar__content-title">{{name}}</h2>
            <button v-b-toggle="modalId" class="btn btn-link-plain btn--select">
                <span class="h6">{{name}}</span>
            </button>
            <b-collapse :id="modalId" :visible="false">
                <slot>
                    
                </slot>
            </b-collapse>
        </div>
    </div>
</template>
<script>
    import uniqid from 'uniqid';
    export default {
        props: {
            name: ''
        },
        data() {
            return {
                modalId: uniqid() + '__footer_support_bar_',
            }
        },
    }
</script>



// WEBPACK FOOTER //
// src/app/components/footer-support-bar-section.vue